import { Link } from "react-router-dom";
export function Footer() {
  return (
    <footer className="footer shell">
      <Link to="/" className="footer-name">
        Fabulous J<span>Emmanuel Adegbulu · Software Engineer</span>
      </Link>
      <p>Built with care. Made to work.</p>
      <a href="#top">Back to top ↑</a>
      <span className="copyright">© {new Date().getFullYear()}</span>
    </footer>
  );
}
